import { Component } from "../lib/component.ts";

/**
 * Sticky mini buy box for mobile. Slides up when the main buy box has scrolled
 * above the viewport, and slides back down when it returns to view.
 */
class BuyBoxMini extends Component {
  #observer: IntersectionObserver | undefined;

  #mediaQuery = window.matchMedia("(width < 940px)");

  connectedCallback(): void {
    super.connectedCallback();

    const buyBox = document.querySelector(".buy-box");
    if (!buyBox) return;

    if (!this.classList.contains("is-visible")) {
      this.style.display = "none";
    }

    this.addEventListener("transitionend", this.#onTransitionEnd, {
      signal: this.signal,
    });

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        if (!this.#mediaQuery.matches) {
          this.classList.remove("is-visible");
          return;
        }
        const hiddenAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (hiddenAbove) {
          this.style.removeProperty("display");
          void this.offsetHeight;
        }
        this.classList.toggle("is-visible", hiddenAbove);
        document.documentElement.style.setProperty(
          "--buy-box-height-sticky",
          hiddenAbove ? `${this.offsetHeight}px` : "0px",
        );
      },
      { threshold: 0 },
    );

    this.#observer.observe(buyBox);

    this.#mediaQuery.addEventListener(
      "change",
      () => {
        if (!this.#mediaQuery.matches) {
          this.classList.remove("is-visible");
          document.documentElement.style.removeProperty("--buy-box-height-sticky");
        }
      },
      { signal: this.signal },
    );

    this.signal.addEventListener("abort", () => {
      this.#observer?.disconnect();
      document.documentElement.style.removeProperty("--buy-box-height-sticky");
    });
  }

  #onTransitionEnd = (e: TransitionEvent): void => {
    if (e.propertyName !== "translate" || this.classList.contains("is-visible")) return;
    this.style.display = "none";
  };
}

if (!customElements.get("buy-box-mini")) {
  customElements.define("buy-box-mini", BuyBoxMini);
}
